
import React, { Component } from 'react';
import { modal } from "@tsinternetsale/common";
import PropTypes from "prop-types";


// A modal popup that include the admin group box with a title
export class EmptyBox extends Component {
    render() {
        return (
            <modal.EmptyBox {...this.props} container={this.props.container}>
                {this.props.children}
            </modal.EmptyBox>
        );
    }
}

EmptyBox.propTypes = {
    container: PropTypes.object
};

// A modal popup that include the admin group box with a title
export class GroupBox extends Component {
    render() {
        return (
            <EmptyBox {...this.props}>
                <h4>{this.props.title}</h4>
                <div className="contentPanel">
                    {this.props.children}
                </div>
            </EmptyBox>
        );
    }
}
GroupBox.propTypes = {
    title: PropTypes.string
};

// A confirm box!
export class Confirm extends Component {
        render() {
            return <modal.Confirm {...this.props}>{this.props.children}</modal.Confirm>
        }
}
Confirm.propTypes = {
    title: PropTypes.string, // The title
    message: PropTypes.string, // The "question"
    messagehtml: PropTypes.string, // The "question"
    buttons: PropTypes.array, // The buttons you want [ { label: "", onClick: function } ]
    onClose: PropTypes.func,
    width: PropTypes.number,
    zIndex: PropTypes.number,
    style: PropTypes.object
};

// Confirm shortcuts
export class ConfirmOK extends Component {
    // Here, onClose={this.props.onOK} is a bug fix that should be done in modal.ConfirmOK instead
    render() {
        return ( <modal.ConfirmOK {...this.props} onClose={this.props.onOK}>{this.props.children}</modal.ConfirmOK> );
    }
}
ConfirmOK.propTypes = {
    onOK: PropTypes.func.isRequired
};

// Confirm shortcutspropTypes: {
export class ConfirmOKCancel extends Component {
    render() {
        return ( <modal.ConfirmOKCancel {...this.props}>{this.props.children}</modal.ConfirmOKCancel>);
    }
}
ConfirmOKCancel.propTypes = {
    onOK: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export class ConfirmYesNo extends Component {
    render() {
        return ( <modal.ConfirmYesNo {...this.props}>{this.props.children}</modal.ConfirmYesNo>);
    }
}
ConfirmYesNo.propTypes = {
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    style: PropTypes.object
};
